import Accordion from "react-bootstrap/esm/Accordion";
import RootLayout from "../../components/layout/RootLayout";
import withAuth from "../../components/withAuth.component";
import User from "../../types/user";
import { getUserRole } from "../../utils/authUtils";
import faqPageIcon from "../../assets/images/faq-page-icon.svg";
import { customerFAQ, generalFAQ } from "./constant";
import { auditorFAQ } from "./constant";
import "./FAQ.css";

function FAQ({ user }: { user: User }) {
  const userRoles = getUserRole(user as User);

  const faqs = [
    ...(userRoles.isAuditor ? auditorFAQ : []),
    ...(userRoles.isCustomer ? customerFAQ : []),
    ...generalFAQ,
  ];

  return (
    <RootLayout
      title="FAQs"
      subtitle="Frequently Asked Questions"
      logo={faqPageIcon}
      logoAlt="FAQ Page"
      showBackButton
    >
      <Accordion defaultActiveKey="0" bsPrefix="faq-accordion">
        {faqs.map((faq, index) => (
          <Accordion.Item key={index} eventKey={index.toString()} bsPrefix="faq-accordion-item">
            <Accordion.Header bsPrefix="faq-accordion-header">
              {faq.question}
            </Accordion.Header>
            <Accordion.Body bsPrefix="faq-accordion-body">
                <>
                  {faq.answer.split(/(https?:\/\/[^\s]+)/).map((part, i) => (
                    part.match(/^https?:\/\//) ? 
                      <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a> : 
                      part
                  ))}
                </>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </RootLayout>
  );
}

export default withAuth(FAQ);
